"use client";

import React from 'react';
import Link from 'next/link';
import { useLocale } from 'next-intl';
import { usePathname } from 'next/navigation';
import styles from './Footer.module.css';

interface FooterProps {
  footerTextZh?: string;
  footerTextEn?: string;
  footerTitleZh?: string;
  footerTitleEn?: string;
}

const Footer = ({ footerTextZh, footerTextEn, footerTitleZh, footerTitleEn }: FooterProps) => {
  const locale = useLocale();
  const pathname = usePathname();

  if (pathname.includes('/login') || pathname.includes('/register')) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footerFullWidth}>
        
        {/* 3. 上方4个按钮 (全宽对称) */}
        <div className={styles.footerTop}>
          <div className={styles.footerBtnWrapper}>
             <Link href={`/${locale}/marketplace`} className={styles.footerBtn}>{locale === 'zh' ? '非遗推荐项目' : 'Projects'}</Link>
          </div>
          <span className={styles.separator}>|</span>
          <div className={styles.footerBtnWrapper}>
             <Link href={`/${locale}/certification`} className={styles.footerBtn}>{locale === 'zh' ? '认证中心' : 'Certification'}</Link>
          </div>
          <span className={styles.separator}>|</span>
          <div className={styles.footerBtnWrapper}>
             <Link href={`/${locale}/news`} className={styles.footerBtn}>{locale === 'zh' ? '新闻' : 'News'}</Link>
          </div>
          <span className={styles.separator}>|</span>
          <div className={styles.footerBtnWrapper}>
             <Link href={`/${locale}/about`} className={styles.footerBtn}>{locale === 'zh' ? '关于我们' : 'About Us'}</Link>
          </div>
        </div>

        {/* 1, 2, 4. 中间行：鲸鱼图片(左) | 文字(右移) | 社交图标(按钮3/4下方) */}
        <div className={styles.footerMainRow}>
          <div className={styles.whaleImage}>
            <img src="/trans_whale.png" alt="Whale Illustration" />
            <span className={styles.footerLogoText}>W I C H P D F</span>
          </div>
          
          <div className={styles.footerMiddleText}>
            <h3 style={{ whiteSpace: 'pre-line' }}>
              {locale === 'zh' ? footerTitleZh : footerTitleEn}
            </h3>
            <p style={{ whiteSpace: 'pre-line' }}>{locale === 'zh' ? footerTextZh : footerTextEn}</p>
          </div>
          
          <div className={styles.socialIcons}>
            <img src="/trans_social_1.png" alt="Social Media 1" />
            <img src="/trans_social_2.png" alt="Social Media 2" />
            <img src="/trans_social_3.png" alt="Social Media 3" />
            <img src="/trans_social_4.png" alt="Social Media 4" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
